import { EventStatus } from 'types';

const EventStatusCodeToLabel = {
  TIMED_OUT: 'Timed out',
  FAILED: 'Failed',
  DELIVERED: 'Delivered',
  CREATED: 'Created'
};

export const convertEventStatusTolabel = (status: EventStatus) => {
  return EventStatusCodeToLabel[status] || '';
};
